import {
  Box,
  ImageList,
  ImageListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";
import UTextField from "../../components/mui/UTextField";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { getAPI } from "../../services/commonService";

// API
import { fni18n } from "../../services/commonService";

import { makeStyles } from "@material-ui/core/styles";
import { theme } from '../../assets/themes';
import UTable from "../../components/mui/UTable";
import { API } from "../../config";

const imageColumns = [
  {
    field: 'id',
    headerName: 'No',
    width: 90,
    hide: true,
  },
  {
    field: 'exitImg',
    headerName: '방출구 이미지',
    align: "center",
    headerAlign: "center",
    renderCell: (params) =>
    (
      <>테스트</>
    ),
  },
  {
    field: 'usrImg',
    headerName: '사용자 이미지',
    width: 80,
    headerAlign: "center",
    align: "center",
  },
  {
    field: 'jnl',
    headerName: '거래명세표',
    width: 80,
    headerAlign: "center",
    align: "center",
  },
];


const dataColumns = [
  {
    field: 'id',
    headerName: 'No',
    width: 90,
    hide: true,
  },
  //Bill
  {
    field: 'billCnt',
    headerName: '지폐',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    colSpan: [
      {
        parentField: 'billCnt',
        field: 'bill100Cnt',
        headerName: '$100',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'billCnt',
        field: 'bill50Cnt',
        headerName: '$50',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'billCnt',
        field: 'bill20Cnt',
        headerName: '$20',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'billCnt',
        field: 'bill10Cnt',
        headerName: '$10',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'billCnt',
        field: 'bill5Cnt',
        headerName: '$5',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'billCnt',
        field: 'bill2Cnt',
        headerName: '$2',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'billCnt',
        field: 'bill1Cnt',
        headerName: '$1',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'billCnt',
        field: 'billTotal',
        headerName: '합계',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        /*valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return "$" + Number(params.value).toLocaleString('en-US');
        }*/
      },
    ],
  },//Coin_in
  {
    field: 'CoinInCnt',
    headerName: '동전',
    width: 50,
    headerAlign: 'center',
    align: 'center',
    colSpan: [
      {
        parentField: 'CoinInCnt',
        field: 'coin100Cnt',
        headerName: '100₵',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'CoinInCnt',
        field: 'coin50Cnt',
        headerName: '50₵',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'CoinInCnt',
        field: 'coin25Cnt',
        headerName: '25₵',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'CoinInCnt',
        field: 'coin10Cnt',
        headerName: '10₵',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'CoinInCnt',
        field: 'coin5Cnt',
        headerName: '5₵',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'CoinInCnt',
        field: 'coin1Cnt',
        headerName: '1₵',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US');
        }
      },
      {
        parentField: 'CoinInCnt',
        field: 'coinTotal',
        headerName: '합계',
        width: 50,
        editable: false,
        align: "right",
        headerAlign: "center",
        /*valueFormatter: (params) => {
          if (params.value == null) {
            return '0';
          }
          return Number(params.value).toLocaleString('en-US') + "₵";
        }*/
      },
    ]
  },
  //Check
  {
    field: 'checkTotal',
    headerName: '수표',
    width: 100,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'total', //**TODO 추가 컬럼
    headerName: '총합계',
    width: 100,
    editable: false,
    align: "right",
    headerAlign: "center",
    /*valueFormatter: (params) => {
      if (params.value == null) {
        return '0';
      }
      return "$" + Number(params.value).toLocaleString('en-US');
    },*/
  },
];
//export default function HistPopUpPage({ history }) {
export default function HistPopUpPage(props) {
  const data = props.data;
  const printRef = useRef();
  const [detailInfo, setDetailInfo] = useState({
    storeCd: "",
    machId: "",
    trnsctDt: "",
    trnsctSeq: "",
    jrnlMsg: "",
    machIp: "",
    machPort: "",
    trnsctKndCd: "",
    trnsctKndCdnm: "",
    userId: "",
    userNm: "",
    grpCd: "",
    grpNm: "",
  });

  const [itemData, setItemData] = useState([
    {
      id: "0",
      img: "1",
      pos: "",
      title:"",
    },
  ]);

  const useStyles = makeStyles({
    table: {
      "& .MuiTableCell-root": {
        border: "1px solid #EAEAEA",
        borderTop: "1px solid #EAEAEA",
      }
    },
    header: {
      fontWeight: "bold",
      "& .MuiTableCell-root": {
        // width:195,
      }
    },
    cellTitle: {
      backgroundColor: theme.custom.appbarBgColor,
    },
    cell: {
      padding: 5
    }
  });
  const classes = useStyles();
  //화면 로드 시
  useEffect(() => {
    const getLoadData = async () => {
      try {
        await loadJournal(data.tid);
      } catch (e) {
        console.log(e.message);
      }
    };
    getLoadData();
  }, []);

  const loadJournal = async (tid) => {
    try {
      await getAPI(API.TRANS.HIST_JRNL, { tid: tid })
        .then((res) => {
          // console.log("loadJournal:");
          // console.log(res.data.result);
          if (res.data.result.length > 0) {
            setDetailInfo(res.data.result[0]);
            loadImages(
              res.data.result[0].machIp,
              res.data.result[0].machPort,
              res.data.result[0].trnsctDt,
              res.data.result[0].trnsctSeq
            );
          } else {
          }
        })
        .catch((error) => {
          console.log(error.message);
        });
    } catch (error) {

    }
  };

  const loadImages = async (ip, port, dt, no) => {

    const token = Math.floor(Math.random() * 1000000) + 1;
    const strUrl = `https://${ip}:${port}/svc/if/setSTILLToken?token=${token}`;
    try {
      await getAPI(strUrl).then((res) => {
        if (res && res.status === 200) {
          const date = dt.substring(0, 8);
          const imgUrl = `https://${ip}:${port}/svc/if/still/${date}/${no}?ip=${window.location.host}&token=${token}`;
          getAPI(imgUrl).then((res2) => {
            // console.log("res2:");
            // console.log(res2);
            if (res2 && res2.status === 200 && res2.data.length > 0) {
              //const _inputData = res2.
              const _inputData = res2.data.map((m) => ({ img: m.imgUri, title: m.pos }));
              setItemData(_inputData);
            }
          }).catch(e=>{
          });
        } else {
        }
      });
    } catch (e) {
    }
  };

  const printFunc = () => {
    let printContent = printRef.current.innerHTML;
    let originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent;

    window.print();
    document.body.innerHTML = originalContent;
    //history.go(0);
  };

  // 
  const dateFormmater = (yyyymmdd) => {
    let date = yyyymmdd;
    if (yyyymmdd.length > 7) {
        const year = yyyymmdd.substring(0,4);
        const month = yyyymmdd.substring(4,6);
        const day = yyyymmdd.substring(6,8);
        const hh = yyyymmdd.substring(8,10);
        const mm = yyyymmdd.substring(10,12);
        const ss = yyyymmdd.substring(12,14);
        date = year + "-" + month + "-" + day + " " + hh + ":" + mm + ":" + ss
    }
    return date;
  }
  const trnsctDt = dateFormmater(data.trnsctDt);

  return (
    <div className="pop-container">
      <Box className="contents">
        <Box>
          <TableContainer className="table-container">
            <Table className="table" size="small" >
              <TableBody>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell-title" >{fni18n('지점')}</TableCell>
                  <TableCell className="table-cell">
                    {/* 점번 */}
                    <UTextField id="branch" name="storeCd" defaultValue={data.storeCd} disabled={true} />
                  </TableCell>

                  <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                  <TableCell className="table-cell">
                    {/* 기번 */}
                    <UTextField id="machId" name="machId" defaultValue={data.machId} disabled={true} />
                  </TableCell>
                  <TableCell className="table-cell-title">{fni18n('브랜드')}</TableCell>
                  <TableCell className="table-cell">
                    {/* 브랜드 */}
                    <UTextField id="brandNm" name="brandNm" defaultValue={data.brandNm} disabled={true} />
                  </TableCell>

                  <TableCell className="table-cell-title">{fni18n('거래일자')}</TableCell>
                  <TableCell className="table-cell">
                    {/* 거래일자 */}
                    <UTextField id="trnsctDt" name="trnsctDt" defaultValue={trnsctDt} disabled={true} />
                  </TableCell>
                </TableRow>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell-title">{fni18n('거래번호')}</TableCell>
                  <TableCell className="table-cell">
                    {/* 거래번호 */}
                    <UTextField id="trnsctSeq" name="trnsctSeq" defaultValue={data.trnsctSeq} disabled={true} />
                  </TableCell>
                  <TableCell className="table-cell-title">{fni18n('거래유형')}</TableCell>
                  <TableCell className="table-cell">
                    {/* 거래유형 */}
                    <UTextField id="trnsctKndCdnm" name="trnsctKndCdnm" defaultValue={data.trnsctKndCdnm} disabled={true} />
                  </TableCell>
                  <TableCell className="table-cell"></TableCell>
                  <TableCell className="table-cell"></TableCell>
                  <TableCell className="table-cell"></TableCell>
                  <TableCell className="table-cell"></TableCell>
                  
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search"></div>
        </Box>
        <UTable columns={dataColumns} rows={[data]} rowPerPage={1} footer={false} />

        <Box>
          <TableContainer className="table-container">
            <Table className="table" size="small">
              <TableBody>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell-title">{fni18n('사용자거래이미지')}</TableCell>
                  <TableCell className="table-cell-title">{fni18n('방출구이미지')}({fni18n('지폐')})</TableCell>
                  <TableCell className="table-cell-title">{fni18n('방출구이미지')}({fni18n('동전')})</TableCell>
                  <TableCell className="table-cell-title">{fni18n('거래명세표')}</TableCell>
                </TableRow>
                <TableRow className="table-row-header">
                <TableCell>
                    <ImageList sx={{  height: 210 }} cols={1} rowHeight={210}>
                        {itemData.map((item) => (
                          item.title === "CAM1"? (
                            <ImageListItem key={item.img}>
                            <img
                              src={`${item.img}?w=210&h=210&fit=crop&auto=format`}
                              srcSet={`${item.img}?w=210&h=210&fit=crop&auto=format&dpr=2 2x`}
                              alt={item.title}
                              loading="lazy"
                            />
                          </ImageListItem>):(<></>)
                        ))}
                      </ImageList>
                  </TableCell>
                  <TableCell>
                    <ImageList sx={{ height: 210 }} cols={1} rowHeight={210}>
                      {itemData.map((item) => (
                        item.title === "CAM2"? (
                          <ImageListItem key={item.img}>
                          <img
                            src={`${item.img}?w=210&h=210&fit=crop&auto=format`}
                            srcSet={`${item.img}?w=210&h=210&fit=crop&auto=format&dpr=2 2x`}
                            alt={item.title}
                            loading="lazy"
                          />
                        </ImageListItem>):(<></>)
                      ))}
                    </ImageList>
                  </TableCell>
                  <TableCell>
                    <ImageList sx={{  height: 210 }} cols={1} rowHeight={210}>
                        {itemData.map((item) => (
                          item.title === "CAM3"? (
                            <ImageListItem key={item.img}>
                            <img
                              src={`${item.img}?w=210&h=210&fit=crop&auto=format`}
                              srcSet={`${item.img}?w=210&h=210&fit=crop&auto=format&dpr=2 2x`}
                              alt={item.title}
                              loading="lazy"
                            />
                          </ImageListItem>):(<></>)
                        ))}
                      </ImageList>
                  </TableCell>
                  <TableCell className="table-cell">
                    <TextField
                      aria-readonly
                      sx={{ width: "100%" }}
                      id="filled-multiline-static"
                      multiline
                      rows={10}
                      variant="filled"
                      size="small"
                      inputProps={{ style: { fontSize: 14 } }}
                      value={detailInfo.jrnlMsg.replaceAll(/(\\n)/g, "\n")} />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </div>
  );
}
